import styled from 'styled-components';
import { colors } from 'global/colors';

export const RedCircle = styled.div`
  width: 25px;
  height: 25px;
  border-radius: 15px;
  background-color: #d9534f;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
`;

export const WhiteCross = styled.i.attrs(() => ({ className: 'fa fa-times' }))`
  color: white;
  cursor: pointer;
`;

export const CompanyNameContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.green};
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  whitespace: nowrap;
  height: 35px;
  font-size: 13px;
`;

export const CompanyLogo = styled.img`
  margin: auto;
  max-width: 100%;
  padding: 5px;
  height: 85px;
`;

export const CompanyLogoWrapper = styled.div`
  height: 80px;
  text-align: center;
`;

export const CompanyCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 145px;
  background-color: #e6e6e6;
  min-width: 160px; // Should not be hard coded
  flex: 0;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 10px 0 10px;
  height: 30px;
`;

export const LabelAndCheckboxContainer = styled.div`
  display: flex;
  cursor: pointer;
`;

export const Table = styled.table``;

export const TableBody = styled.tbody``;

export const Td = styled.td`
  text-align: left;
`;

export const Th = styled.th`
  text-align: left;
`;

export const Tr = styled.tr`
  &:nth-child(odd) {
    border: 1px solid #dee2e6;
    border-color: #fbfcfc;
    background-color: rgb(240 240 241);
  }
  &:nth-child(even) {
    border: 1px solid #dee2e6;
    border-color: #fbfcfc;
    background-color: #fff;
  }
`;

export const Input = styled.input``;

export const FlexContainer = styled.div`
  display: flex;
`;

export const ErrorText = styled.label`
  color: red;
  font-size: 14px;
  margin-bottom: ${(props) => props.marginBottom || '0px'};
  margin-top: ${(props) => props.marginTop || '10px'};
`;

export const CardContainer = styled.div`
  display: block;
  width: 200px;
  border: 1px solid #e5e5e5;
  border-radius: 0.25rem;
`;

export const PlanHeader = styled.div`
  background-color: ${colors.green};
  color: white;
  text-align: center;
  padding: 10px;
`;

export const PlanFooter = styled.div`
  background-color: ${colors.lightGray};
  color: white;
  text-align: center;
  padding: 10px;
`;

export const PlanBody = styled.div`
  text-align: center;
  padding: 10px;
`;

export const Price = styled.p`
  color: ${colors.darkBlue};
  font-size: 20px;
  font-weight: 600;
`;

export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const PlanLabel = styled.label`
  color: ${colors.gray2};
  margin-bottom: 0;
`;

export const BlockContainer = styled.div`
  display: block;
`;
